import {
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { font } from "../../../styles/font";
import { TextFieldMA } from "../../../styles/styledComponents";
import { theme } from "../../../styles/theme";
import validator from "validator";
import { VerifyForgotPassword } from "./verifyForgotPassword";
import { ResetPassword } from "./resetPassword";
import { IconBack } from "../../../svgIcons/icons";
import { HttpStatusCode } from "axios";
import { forgotPassword } from "../../../api/controllers/userController";
import { GlobalSnackBar } from "../../../components/snackBar";
import { ButtonCustom } from "../../../components/button";
import { SideBanner } from "../../../components/maSideBanner";
import { GlobalLoaders } from "../../../components/loaders/globalLoader";

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation()
  const loginQuery = useMediaQuery("(max-width:800px)");
  const [fpSnack, setFpSnack] = useState(false);
  const [error, setError] = useState("");
  const [loaderState, setLoaderState] = useState(false);
  const [loaderStateOtp, setLoaderStateOtp] = useState(false);
  const [email, setEmail] = useState(null);
  const [forgotNavigation, setForgotNavigation] = useState(0);

  const handleForgotPassword = async () => {
    if (!email) {
      setEmail("");
    }
    if (email && validator.isEmail(email)) {
      console.log("api call");
      setLoaderState(true)
      try {
        let response = await forgotPassword({
          email,
        });
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          setLoaderState(false)

          setError(response.data.message);
          setFpSnack(true);
          setTimeout(() => {
            setForgotNavigation(1);
          }, 3000);
        }
        if (response.status === HttpStatusCode.BadRequest) {
          setLoaderState(false)

          setError(response.data.message);
          setFpSnack(true);

        }
        if (response.status === HttpStatusCode.InternalServerError) {
          setLoaderState(false)

          setError(response.data.message);
          setFpSnack(true);

        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <>
      <Box
        display={"flex"}
        width="100vw"
        height={"100vh"}
        backgroundColor={theme.col_1}
        alignItems="center"
      >
        <SideBanner query={loginQuery} />

        <Box
          display={"flex"}
          flexDirection="column"
          width={loginQuery ? "100%" : "65%"}
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          backgroundColor={"white"}
        >
          {forgotNavigation !== 0 ? (
            <Box width="100%">
              <IconButton
                onClick={() => setForgotNavigation(forgotNavigation - 1)}
              >
                <IconBack />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
          <Box
            display={"flex"}
            gap="26px"
            flexDirection="column"
            justifyContent={"center"}
            alignItems="center"
            width={loginQuery ? "90%" : "53%"}
            height="100%"
          >
            <Box
              display={"flex"}
              flexDirection="column"
              justifyContent="center"
              alignItems={"center"}
              height="100px"
              width="100%"
              gap='7px'
            >
              <Box
                display={"flex"}
                width="76px"
                justifyContent="center"
                height="60px">
                <img
                  width={"100%"}
                  height="100%"
                  src={require("../../../assets/images/logo.png")}
                  alt='Mindamigo'
                />
              </Box>
              <Box
                display="flex"
                width="100%"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  flex="1"
                  color={theme.col_2}
                  textAlign="center"
                  fontSize={font.size.fs_2}
                  fontWeight="bold"
                >
                  {forgotNavigation === 0
                    ? location.pathname === '/admin-change-password' ? "Change Password" : "Forgot Password"
                    : forgotNavigation === 1
                      ? "Verify OTP"
                      : location.pathname === '/admin-change-password' ?  "Change Password" :"Reset Password"}
                </Typography>
              </Box>
            </Box>
            {forgotNavigation === 0 ? (
              <>
                <Box
                  display="flex"
                  width="100%"
                  flexDirection="column"
                  gap="12px"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box
                    display="flex"
                    width="100%"
                    flexDirection={loginQuery ? "column" : "flex"}
                    gap="16px"
                    justifyContent="center"
                  >
                    <TextFieldMA
                      required
                      error={
                        email === null
                          ? false
                          : !validator.isEmail(email) && email !== ""
                            ? true
                            : email === ""
                              ? true
                              : false
                      }
                      helperText={
                        email === null
                          ? ""
                          : !validator.isEmail(email) && email !== ""
                            ? "Enter valid email"
                            : email === ""
                              ? "Email is required"
                              : ""
                      }
                      onBlur={(e) => setEmail(e.target.value)}
                      fullWidth
                      label="Email"
                    />
                  </Box>
                </Box>
                <Box
                  display="flex"
                  flexDirection={"column"}
                  width="100%"
                  gap="16px"
                  alignItems="center"
                  justifyContent="center"
                >
                  <ButtonCustom
                    loaderState={loaderState}
                    disabled={loaderState}
                    onClick={handleForgotPassword}
                    fullWidth={true}
                    borderRadius="42px"
                    size="large"
                    background={theme.col_2}
                    backgroundRipple={theme.col_3}
                    focusColor={theme.col_1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_3}
                        fontWeight="bold"
                        color={theme.col_4}
                      >
                        GET CODE
                      </Typography>
                    }
                  />
                  {location.pathname === '/admin-change-password' ? <> <Typography
                      fontFamily={font.family.fm_2}
                      onClick={() => navigate("/admin-signin")}
                      sx={{ "&:hover": { textDecoration: "underline" },cursor:'pointer' }}
                      color={theme.col_3}
                      textAlign="center"
                      fontSize={font.size.fs_4}
                      fontWeight="bold"
                    >
                      Sign In
                    </Typography></> :<Typography
                    fontFamily={font.family.fm_2}
                    color={theme.txtAlpha}
                    textAlign="center"
                    fontSize={font.size.fs_4}
                    fontWeight="bold"
                    display={"flex"}
                    alignItems="center"
                    gap="5px"
                  >
                    Don't have an account?{" "}
                    <Typography
                      fontFamily={font.family.fm_2}
                      onClick={() => navigate("/signup")}
                      sx={{ "&:hover": { textDecoration: "underline" },cursor:'pointer' }}
                      color={theme.col_3}
                      textAlign="center"
                      fontSize={font.size.fs_4}
                      fontWeight="bold"
                    >
                      Create an account
                    </Typography>
                  </Typography>}
                </Box>{" "}
              </>
            ) : (
              <>
                <ForgotNavigation
                loaderStateOtp={loaderStateOtp}
                setLoaderStateOtp={setLoaderStateOtp}
                  loginQuery={loginQuery}
                  setFpSnack={setFpSnack}
                  email={email}
                  setError={setError}
                  setForgotNavigation={setForgotNavigation}
                  forgotNavigation={forgotNavigation}
                />
              </>
            )}
          </Box>
        </Box>
      </Box>
      {loaderStateOtp ? <GlobalLoaders/> : <></> }
      <GlobalSnackBar open={fpSnack} title={error} close={setFpSnack} />
    </>
  );
};

const ForgotNavigation = ({
  forgotNavigation,
  setFpSnack,
  setError,
  setForgotNavigation,
  email,
  loginQuery,
  loaderStateOtp, setLoaderStateOtp
}) => {
  switch (forgotNavigation) {
    case 1:
      return (
        <VerifyForgotPassword
        loaderStateOtp={loaderStateOtp}
        setLoaderStateOtp={setLoaderStateOtp}
          loginQuery={loginQuery}
          email={email}
          setFpSnack={setFpSnack}
          setError={setError}
          setForgotNavigation={setForgotNavigation}
        />
      );
    case 2:
      return (
        <ResetPassword
          email={email}
          setFpSnack={setFpSnack}
          setError={setError}
          setForgotNavigation={setForgotNavigation}
        />
      );
    default:
      return;
  }
};
